<template>
  <transition @enter="enter" @leave="leave" appear>
    <span
      v-if="$store.state.currentGame.questionsIndex < 0
        || $store.state.currentGame.questionsIndex === null"
      class="bg-illustration"
    />
  </transition>
</template>

<script>
import anime from '@/assets/libs/anime';

export default {
  name: 'BgIllustration',

  methods: {
    enter(el, done) {
      anime({
        targets: el,
        scale: [1.7, 1.2],
        opacity: [0, 0.5],
        easing: 'cubicBezier(.5,0,0,1)',
        duration: 1800,
        complete: done,
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        scale: [1.2, 1.7],
        opacity: [0.5, 0],
        easing: 'cubicBezier(.5,0,0,1)',
        duration: 1800,
        complete: done,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-illustration {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-image: url('/img/illustrations/bg_mobile.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  mix-blend-mode: multiply;
  pointer-events: none;

  @include mq(ipadP) {
    background-image: url('/img/illustrations/bg_desktop.png');
  }
}
</style>
